import React from 'react'
import "./Contact.css"
import stepth from "../../assets/images/steph.jpg"
import { FiGithub, FiMail, FiMap, FiPhoneCall, FiUser, FiSend } from 'react-icons/fi'

const Contact = () => {
    return (
        <section className='contact-cyber' id="contacts">
            <div className='contact-container'>
                {/* Colonne Infos */}
                <div className='contact-info-card'>
                    <div className='card-header'>
                        <span className='line'></span>
                        <h2>LIAISON_DIRECTE</h2>
                    </div>

                    <div className='info-grid'>
                        <div className='info-item'>
                            <div className='icon-box'><FiUser /></div>
                            <div className='text-box'>
                                <label>IDENTITÉ</label>
                                <span>Stéphane Kikoni Zeus</span>
                            </div>
                        </div>

                        <div className='info-item'>
                            <div className='icon-box'><FiMap /></div>
                            <div className='text-box'>
                                <label>LOCALISATION</label>
                                <span>Kinshasa, RDC</span>
                            </div>
                        </div>

                        <div className='info-item' onClick={() => window.location.href = 'tel:+243817247035'}>
                            <div className='icon-box'><FiPhoneCall /></div>
                            <div className='text-box'>
                                <label>COMMUNICATION</label>
                                <span>+243 81 724 7035</span>
                            </div>
                        </div>

                        <div className='info-item' onClick={() => window.location.href = 'mailto:kikonistephane@gmail.com'}>
                            <div className='icon-box'><FiMail /></div>
                            <div className='text-box'>
                                <label>CANAL EMAIL</label>
                                <span>kikonistephane@gmail.com</span>
                            </div>
                        </div>

                        <div className='info-item' onClick={() => window.open('https://github.com/StephaneCash', '_blank')}>
                            <div className='icon-box'><FiGithub /></div>
                            <div className='text-box'>
                                <label>RESOURCES SOURCE</label>
                                <span>github.com/StephaneCash</span>
                            </div>
                        </div>
                    </div>

                    <button className='ping-btn'>
                        ENVOYER UN SIGNAL <FiSend />
                    </button>
                </div>

                {/* Colonne Photo avec effet Frame */}
                <div className='contact-image-card'>
                    <div className='image-frame'>
                        <div className='corner top-left'></div>
                        <div className='corner top-right'></div>
                        <div className='corner bottom-left'></div>
                        <div className='corner bottom-right'></div>
                        <img src={stepth} alt="Stéphane Kikoni" />
                        <div className='image-overlay-glow'></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact;